module.exports = __webpack_public_path__ + "img/ski_sub_title8m.4d3142e1.jpg";